import React, { useState } from "react";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Gift, Copy } from "lucide-react";
import { toast } from "sonner";

const InviteButton = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  if (!user?.referral_code) return null;
  const link = `${window.location.origin}/login?ref=${user.referral_code}`;
  const share = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Invite link copied");
    } catch { toast.error("Copy failed"); }
  };
  return (
    <>
      <Button data-testid="invite-btn" variant="ghost" size="icon" onClick={() => setOpen(true)} className="text-amber-600 hover:text-amber-700"><Gift className="w-4 h-4"/></Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle>Invite friends · earn ₹100</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div className="text-sm text-slate-600">Share your code. When a friend joins and completes their first delivery, you both get ₹100 in CarryIt credit.</div>
            <div className="rounded-2xl bg-slate-900 text-white p-5 text-center">
              <div className="text-xs text-slate-400 uppercase tracking-widest">Your referral code</div>
              <div className="font-mono text-3xl font-extrabold mt-1 tracking-widest" data-testid="referral-code">{user.referral_code}</div>
            </div>
            <div className="flex gap-2">
              <div className="flex-1 rounded-xl bg-slate-100 px-3 py-2 text-xs font-mono truncate">{link}</div>
              <Button data-testid="copy-invite-btn" onClick={share} size="sm" className="bg-amber-600 hover:bg-amber-700"><Copy className="w-4 h-4 mr-1"/> Copy</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InviteButton;
